<template>
    <svg class="fill-current inline"
         version="1.2"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         overflow="visible"
         preserveAspectRatio="none"
         viewBox="0 0 24 24"
         width="18"
         height="18">
        <g>
            <path xmlns:default="http://www.w3.org/2000/svg" id="phone" d="M19.33,16.26c0.01-0.07,0.01-0.15,0-0.22c-0.21-0.25-0.48-0.44-0.79-0.55l-0.56-0.31l-0.66-0.36l-0.56-0.32  l-0.26-0.18c-0.12-0.08-0.24-0.16-0.37-0.22c-0.1-0.06-0.21-0.09-0.33-0.09c-0.2,0.03-0.39,0.14-0.52,0.3  c-0.21,0.2-0.4,0.42-0.57,0.65c-0.17,0.23-0.35,0.45-0.55,0.65c-0.12,0.16-0.29,0.26-0.48,0.3c-0.08,0-0.16-0.02-0.23-0.05  l-0.21-0.09L13,15.61l-0.2-0.12c-0.9-0.49-1.72-1.1-2.45-1.81c-0.71-0.73-1.32-1.55-1.81-2.45L8.4,11.01l-0.15-0.25  c-0.03-0.07-0.06-0.14-0.09-0.21c-0.03-0.07-0.05-0.15-0.05-0.23c0.04-0.19,0.14-0.36,0.3-0.48c0.2-0.2,0.42-0.38,0.65-0.55  C9.29,9.12,9.5,8.93,9.7,8.73C9.86,8.6,9.97,8.41,10,8.21c0-0.1-0.02-0.21-0.07-0.3C9.86,7.78,9.79,7.66,9.7,7.54L9.52,7.28  L9.2,6.73L8.83,6.07L8.52,5.5C8.42,5.2,8.24,4.92,8,4.71c-0.07-0.01-0.15-0.01-0.22,0c-0.25,0.01-0.49,0.04-0.73,0.1  C6.79,4.85,6.54,4.92,6.3,5.01c-0.49,0.3-0.87,0.74-1.1,1.26C4.86,6.86,4.68,7.53,4.67,8.21c-0.01,0.18-0.01,0.37,0,0.55  c0.03,0.2,0.07,0.4,0.13,0.6C4.89,9.58,4.95,9.74,5,9.85l0.2,0.58l0.19,0.51c0.22,0.64,0.51,1.25,0.86,1.82  c0.64,1,1.4,1.92,2.25,2.75c0.83,0.85,1.75,1.61,2.75,2.25c0.57,0.35,1.18,0.64,1.82,0.86l0.51,0.19l0.58,0.2l0.49,0.15  c0.2,0.06,0.4,0.1,0.6,0.13c0.18,0.01,0.37,0.01,0.55,0c0.68-0.01,1.35-0.19,1.94-0.53c0.52-0.22,0.95-0.58,1.26-1.05  c0.1-0.23,0.17-0.46,0.23-0.7c0.06-0.24,0.09-0.48,0.1-0.73l0,0V16.26z" style="fill: rgb(120, 120, 120);" vector-effect="non-scaling-stroke"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "PhoneSVG"
    }
</script>

<style scoped>

</style>